<template>
	<v-container id="dashboard-view" fluid tag="section">
		<v-row>
			<v-col cols="12" md="12">
				<material-card icon="mdi-alert" icon-small title="" color="accent">
					<template #title>
						<div class="text-center grey--text text-h5">
							کاربر گرامی، اعتبار نرم افزار شما در تاریخ <span class="red--text">{{ expireDate_persian }}</span> به پایان {{ verb }}.
							<br />
							جهت ادامه استفاده از نرم افزار می توانید از طریق یکی از روش های زیر، اقدام به خرید آنلاین نرم افزار نمایید.
						</div>
					</template>
					<div class="px-5">
						<v-row class="my-5">
							<v-col cols="12" md="6">
								<v-card color="#eeeeee" theme="light">
									<v-card-title class="text-h5 justify-center mb-2">
										شارژ پرونده ای یکساله (ابری)
									</v-card-title>

									<v-card-subtitle class="text-right mb-1">
										در این روش اعتبار اکانت کاربری شما به مدت یک سال شارژ می شود و نسبت به رشد کسب و کار خود، هزینه مدیریت پرونده ها را پرداخت می نمایید و از تمام بخش های نرم افزار استفاده نمایید.
									</v-card-subtitle>
									<v-card-subtitle class="text-right mb-1">
										جهت اخذ اینماد و فعالسازی درگاه پرداخت آنلاین، امکان اتصال به دامنه اختصاصی شما و درج لینک اینماد در صفحه اختصاصی شما مهیا می باشد و می توانید با شماره پشتیبانی 09361995434 تماس حاصل فرمایید.
									</v-card-subtitle>
									<v-card-subtitle class="text-h3 text-center blue--text">قیمت: {{ cloudPrice.toString().toPriceFormat() }} تومان&nbsp;<span class="text-h6">(هر پرونده)</span></v-card-subtitle>

									<v-card-actions class="justify-center">
										<v-card color="white" class="mx-5 pa-5">
											<v-form ref="cloudForm" lazy-validation>
												<v-row>
													<v-col cols="12" class="pb-0">
														<v-text-field outlined v-model="count" class="left-input" label="تعداد پرونده مورد نظر خود را وارد کنید" :rules="[() => Number(count) > 0 || 'تعداد پرونده را به صورت صحیح وارد کنید', () => Number(count) >= 10 || 'حداقل تعداد شارژ ۱۰ پرونده می باشد']" required />
													</v-col>
													<v-col cols="12" class="pt-0">
														<v-text-field outlined v-model="affCode1" class="pt-0 left-input" label="کد معرف خود را در صورت وجود وارد کنید" />
													</v-col>
												</v-row>
												<div class="text-center">
													<v-btn color="success" @click="purchase(1)" variant="outlined" :loading="loading">
														قابل پرداخت: {{ String(payable).toPriceFormat() }} تومان
														<br />
														پرداخت و خرید آنلاین
													</v-btn>
												</div>
											</v-form>
										</v-card>
									</v-card-actions>
								</v-card>
							</v-col>
							<v-col cols="12" md="6">
								<v-card color="#eeeeee" theme="light">
									<v-card-title class="text-h5 justify-center mb-2">
										نامحدود یکساله (ابری)
									</v-card-title>

									<v-card-subtitle class="text-right mb-1">
										در این روش اعتبار اکانت کاربری شما به مدت یک سال شارژ می شود و می توانید به تعداد نامحدود ثبت پرونده داشته باشید و از تمام بخش های نرم افزار استفاده نمایید.
									</v-card-subtitle>
									<v-card-subtitle class="text-right mb-1">
										جهت اخذ اینماد و فعالسازی درگاه پرداخت آنلاین، امکان اتصال به دامنه اختصاصی شما و درج لینک اینماد در صفحه اختصاصی شما مهیا می باشد و می توانید با شماره پشتیبانی 09361995434 تماس حاصل فرمایید.
									</v-card-subtitle>
									<v-card-subtitle class="text-h3 text-center blue--text">قیمت: {{ permanentPrice.toString().toPriceFormat() }} تومان</v-card-subtitle>

									<v-card-actions class="justify-center">
										<v-card color="white" class="mx-5 pa-5" style="width:100%">
											<v-form lazy-validation>
												<v-row>
													<v-col cols="12">
														<v-text-field outlined v-model="affCode2" class="pt-0 left-input" label="کد معرف خود را در صورت وجود وارد کنید" />
													</v-col>
												</v-row>
												<div class="text-center">
													<v-btn color="success" @click="purchase(0)" variant="outlined" :loading="loading">
														پرداخت و خرید آنلاین
													</v-btn>
												</div>
											</v-form>
										</v-card>
									</v-card-actions>
								</v-card>
							</v-col>
							<v-col cols="12" md="12">
								<v-card color="#eeeeee" theme="light">
									<v-card-title class="text-h5 justify-center mb-2">
										نسخه دائمی سفارشی (غیر ابری)
									</v-card-title>

									<v-card-subtitle class="text-right mb-1">
										نسخه دائمی نرم افزار محدودیتی در مدت زمان استفاده از نرم افزار و ثبت پرونده نداشته و قابلیت نصب و راه اندازی بر روی هاست و دامنه اختصاصی شما را داراست.
									</v-card-subtitle>
									<v-card-subtitle class="text-right mb-1">
										نسخه دائمی قابلیت اختصاصی سازی طبق نیاز شما را دارد. قبل از خرید با کارشناسان ما در ارتباط باشید تا از انجام تغییرات مطمئن شوید
									</v-card-subtitle>

									<v-card-actions class="justify-center">
										<v-card color="white" class="mx-5 pa-5" style="width:100%">
											<v-form lazy-validation>
												<v-row>
													<v-col cols="12">
														<v-text-field outlined v-model="affCode2" class="pt-0 left-input" label="کد معرف خود را در صورت وجود وارد کنید" />
													</v-col>
												</v-row>
												<div class="text-center">
													<!-- <v-btn color="success" @click="purchase(0)" variant="outlined" :loading="loading">
														پرداخت و خرید آنلاین
													</v-btn> -->
													<div class="green--text mb-5">
														جهت اطلاع از قیمت نهایی با ما تماس حاصل فرمایید
													</div>
													<div>
														<a href="https://jetafzaar.ir/تماس-با-ما/" target="_blank">
															<v-btn color="success">
																ارتباط با واحد فروش
															</v-btn>
														</a>
													</div>
												</div>
											</v-form>
										</v-card>
									</v-card-actions>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</material-card>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	// Utilities
	export default {
		name: 'Buy',

		data: () => ({
			affCode1: '',
			affCode2: '',
			count: 100,
			loading: false,
			cart: {
				actionIcon: 'mdi-alert',
				actionText: '',
				color: 'red',
				icon: 'mdi-alert',
				title: '',
				route: '/admin/report-member-loans',
				value: 'خرید',
			}
		}),

		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			...get('siteConfig', [
				'permanentPrice', 'cloudPrice'
			]),
			expireDate_persian() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) {
					return `${new Date(user.userData.customer.expireDate).toLocaleDateString('fa-IR')}`
				}
				return '-----'
			},
			remainDays() {
				var user = this.getCurrentUser
				if (!user || !user.userData || !user.userData.customer)
					return 0
				const date1 = new Date()
				const date2 = new Date(user.userData.customer.expireDate)
				const diffTime = Math.max((date2 - date1), 0)
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
				return diffDays
			},
			verb() {
				return this.remainDays > 0 ? 'خواهد رسید' : 'رسیده است'
			},
			payable() {
				let price = this.count * this.cloudPrice
				// let discountPercent = Math.min(this.count / 100 * 5, 20)
				let discountPercent = 0
				price = price - (price * discountPercent / 100)
				return price
			}
		},

		mounted() {
		},
		methods: {
			purchase(productType) {
				if (!this.$refs.cloudForm.validate())
					return
				this.loading = true
				let data = {
					productType: productType,
					paymentMethod: 0,
					affCode: productType === 1 ? this.affCode1 : this.affCode2,
					loanCount: this.count
				}
				api.post('admin/purchase/create', data)
					.then(
						response => {
							window.location.replace(response)
						})
					.catch(err => {
						this.loading = false
						toast.error(err.message)
					})

			}
		},
	}
</script>
